import React from 'react'
import Supplement from '@components/brand/supplement'

const SupplementPage = () => {
  return <Supplement />
}

export default SupplementPage
